import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CSS = `
.cg-modal__scrim {
  position: fixed; inset: 0; background: var(--scrim);
  display: flex; align-items: center; justify-content: center; padding: var(--space-5);
  z-index: var(--z-modal);
}
.cg-modal {
  background: var(--surface-card); border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-overlay); width: 100%; max-height: 90vh;
  display: flex; flex-direction: column; overflow: hidden; font-family: var(--font-sans);
}
@media (prefers-reduced-motion: no-preference) {
  .cg-modal { animation: cgModalIn var(--duration-slow) var(--ease-spring); }
  @keyframes cgModalIn { from { transform: translateY(12px) scale(.98); } to { transform: none; } }
}
.cg-modal--sm { max-width: 400px; }
.cg-modal--md { max-width: 560px; }
.cg-modal--lg { max-width: 760px; }
.cg-modal__header {
  display: flex; align-items: center; justify-content: space-between; gap: var(--space-4);
  padding: var(--space-5) var(--space-5) var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
}
.cg-modal__title { font-size: var(--text-xl); font-weight: var(--weight-bold); color: var(--text-heading); letter-spacing: var(--tracking-tight); }
.cg-modal__close {
  flex-shrink: 0; width: 32px; height: 32px; border-radius: var(--radius-md);
  background: var(--slate-100); border: none; cursor: pointer; color: var(--text-muted);
  display: inline-flex; align-items: center; justify-content: center;
  transition: background var(--duration-fast), color var(--duration-fast);
}
.cg-modal__close:hover { background: var(--slate-200); color: var(--text-heading); }
.cg-modal__close svg { width: 18px; height: 18px; }
.cg-modal__body { padding: var(--space-5); overflow-y: auto; color: var(--text-body); font-size: var(--text-base); line-height: var(--leading-normal); }
.cg-modal__footer {
  display: flex; align-items: center; justify-content: flex-end; gap: var(--space-3);
  padding: var(--space-4) var(--space-5); border-top: 1px solid var(--border-subtle);
  background: var(--slate-50);
}
`;
function injectStyles() {
    if (typeof document !== 'undefined' && !document.getElementById('cg-modal-css')) {
        const s = document.createElement('style');
        s.id = 'cg-modal-css';
        s.textContent = CSS;
        document.head.appendChild(s);
    }
}
const CloseIcon = () => (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "m18 6-12 12M6 6l12 12" }) }));
export function Modal({ open = true, title = '', size = 'md', onClose, footer = null, children, className = '', ...rest }) {
    injectStyles();
    if (!open)
        return null;
    return (_jsx("div", { className: "cg-modal__scrim", onClick: onClose, children: _jsxs("div", { className: `cg-modal cg-modal--${size}${className ? ` ${className}` : ''}`, role: "dialog", "aria-modal": "true", onClick: (e) => e.stopPropagation(), ...rest, children: [(title || onClose) && (_jsxs("div", { className: "cg-modal__header", children: [_jsx("h2", { className: "cg-modal__title", children: title }), onClose && (_jsx("button", { className: "cg-modal__close", "aria-label": "Close", onClick: onClose, children: _jsx(CloseIcon, {}) }))] })), _jsx("div", { className: "cg-modal__body", children: children }), footer && _jsx("div", { className: "cg-modal__footer", children: footer })] }) }));
}
